// Baserow-Konfiguration für die Carpool-App
// Diese Datei enthält alle Feld-IDs und Tabellen-IDs für die Baserow-Integration

export const BASEROW_CONFIG = {
  // API-Basis-URL (geht jetzt über das BFF)
  BASE_URL: '/api',
  
  // Tabellen-IDs
  TABLES: {
    VEHICLES: 1213,           // Fahrzeuge Tabelle
    DAMAGE_REPORTS: 1214,     // carpool_claim_management Tabelle
    DOCUMENTS: 568,           // documents Tabelle
    LICENSE_CHECKS: 1225,     // carpool_license_check Tabelle
    USERS: 546                // users Tabelle (aus API-Dokumentation)
  },
  
  // Feld-IDs für Fahrzeuge (Tabelle 1213)
  VEHICLE_FIELDS: {
    LICENSE_PLATE: 'field_12500',      // license_plate - Text
    VIN: 'field_12501',                // vin - Text
    MODEL: 'field_12502',              // model - Text
    MANUFACTURER: 'field_12503',       // manufacturer - Single select
    TYPE: 'field_12504',               // type - Single select
    TYPE_OF_CAR: 'field_12505',        // type_of_car - Single select
    POOLCAR: 'field_12506',            // poolcar - Boolean
    USER: 'field_12507',               // user - Link to another table
    TAXATION: 'field_12643',           // taxation - Single select
    END_OF_CONTRACT: 'field_12508',    // end_of_contract - Date
    CONTRACT_END_DATE: 'field_12509',  // contract_end_date - Date
    TUEV_UNTIL: 'field_12510',         // tuev_until - Date
    TYPE_OF_CONTRACT: 'field_12511',   // type_of_contract - Single select
    KM: 'field_12512',                 // km - Number
    MONTHLY_NET_SUM: 'field_12513',    // monthly_net_sum - Text
    MONTHLY_GROSS_SUM: 'field_12514',  // monthly_gross_sum - Text
    DATE_OF_LAST_KM_CHECK: 'field_12515', // date_of_last_km_check - Date
    IMAGES: 'field_12516'              // images - File (mehrere Bilder)
  },
  
  // Feld-IDs für Schadensmeldungen (Tabelle 1214)
  DAMAGE_REPORT_FIELDS: {
    TITLE: 'field_12527',              // title - Text
    CARPOOL: 'field_12528',            // carpool - Link to another table
    DESCRIPTION: 'field_12529',        // description - Long text
    STATUS: 'field_12532',             // status - Single select
    ESTIMATED_COSTS: 'field_12534',    // estimated_costs - Number
    REAL_COSTS: 'field_12535',         // real_costs - Number
    DOCUMENTS: 'field_12536',          // documents - Link to another table
    TODOS: 'field_12537',              // todos - Long text (JSON)
    HISTORY: 'field_12538',            // history - Long text (JSON)
    NOTES: 'field_12539'               // notes - Long text
  },
  
  // Feld-IDs für Führerscheinkontrolle (Tabelle 1225)
  LICENSE_CHECK_FIELDS: {
    TITLE: 'field_12644',              // title - Text
    USER: 'field_12645',               // user - Link to another table (Tabelle 546)
    IS_CHECKED: 'field_12646',         // is_checked - Boolean
    CHECK_DATE: 'field_12648',         // check_date - Date
    UPLOADED_FILE: 'field_12651',      // uploaded_file - Link to documents table (Tabelle 568)
    NOTES: 'field_12653'               // notes - Long text
  },
  
  // Status-Optionen für Schadensmeldungen
  DAMAGE_STATUS_OPTIONS: {
    GEMELDET: 5382,           // "Gemeldet"
    IN_BEARBEITUNG: 5383,     // "In Bearbeitung"
    ERLEDIGT: 5384            // "Erledigt"
  },
  
  // Status-Optionen für Führerscheinkontrolle (MUSS ANGEPASST WERDEN)
  LICENSE_STATUS_OPTIONS: {
    VALID: 5500,              // "valid"
    EXPIRING_SOON: 5501,      // "expiring_soon"
    EXPIRED: 5502             // "expired"
  },
  
  // Versteuerungs-Optionen
  TAXATION_OPTIONS: {
    NONE: 5425,               // "Keine Versteuerung"
    COMBUSTION: 5426,         // "1% Verbrenner"
    HYBRID: 5427,             // "0,5% Hybrid"
    ELECTRIC: 5428            // "0,25% Elektro"
  }
};

// Hilfsfunktionen für die Konfiguration
export const getTableUrl = (tableId: number) => {
  return `${BASEROW_CONFIG.BASE_URL}/database/rows/table/${tableId}/`;
};

export const getFieldId = (table: keyof typeof BASEROW_CONFIG, field: string) => {
  const tableFields = BASEROW_CONFIG[table] as Record<string, string>;
  return tableFields[field];
};

// Beispiel für die Verwendung:
// const vehicleTableUrl = getTableUrl(BASEROW_CONFIG.TABLES.VEHICLES);
// const licensePlateField = getFieldId('VEHICLE_FIELDS', 'LICENSE_PLATE'); 